import presidentSrc from '../assets/images/foto-allan.jpg';
import directorSrc from '../assets/images/foto-luca.jpg';

const mock = [{
  image: presidentSrc,
  name: 'Allan Rocha',
  role: 'Presidente, diretor científico e pesquisador',
  social: {
    facebook: '',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/allan-rocha-de-souza/',
    instagram: 'https://www.instagram.com/prof.allanrocha/',
    dribble: '',
    site: '',
    lattes: 'http://lattes.cnpq.br/5178459691896082'
  },
  description: 'Doutor em direito civil pela UERJ, com pós doutorado em direito comparado na Oxford University. Professor e pesquisador no curso de direito do ITR/UFRRJ, no Programa de Pós Graduação em Políticas Públicas, Estratégias e Desenvolvimento (PPED/IE/UFRJ) e na especialização em PI da PUC-RJ. Vice coordenador do Instituto Nacional de Ciências e Tecnologia (INCT) Proprietas. Advogado e consultor jurídico.',
}, {
  image: directorSrc,
  name: 'Luca Schirru',
  role: 'Diretor executivo e pesquisador',
  social: {
    facebook: '',
    twitter: '',
    linkedin: 'https://www.linkedin.com/in/lucaschirru/',
    instagram: 'https://www.instagram.com/lucaschirru_',
    dribble: '',
    site: '',
    lattes: 'http://lattes.cnpq.br/7444096365092483'
  },
  description: 'Doutor e mestre em Políticas Públicas, Estratégias e Desenvolvimento (PPED/IE/UFRJ). Arcadia Research Fellow e LL.M Candidate (IP & Technology - AUWCL). Professor na especialização em PI da PUC/RJ. Advogado e consultor jurídico.',
}];

export default mock;